import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const REMOVE_SFTP_CREDENTIALS_MUTATION = gql`
  mutation removeSftpCredential($where: SftpCredentialWhereUniqueInput!) {
    removeSftpCredential(where: $where) {
      id
    }
  }
`;

@Injectable({ providedIn: 'root' })
export class RemoveSftpCredentialMutation extends Mutation<RootMutation> {
  document = REMOVE_SFTP_CREDENTIALS_MUTATION;
}
